import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { GoogleCallback } from '$src/modules/auth/GoogleCallback'

const searchSchema = z.object({
  code: z.string().optional(),
  error: z.string().optional(),
})

export const Route = createFileRoute('/auth/google/callback')({
  component: GoogleCallback,
  validateSearch: searchSchema,
})
